(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["humana-size-shop"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__hmnQsInit) return;
    window.__hmnQsInit = true;

    // Match the band + circle white to the actual page background.
    (function matchBg() {
      function transparent(c) { return !c || c === 'transparent' || c === 'rgba(0, 0, 0, 0)'; }
      function apply() {
        var c = getComputedStyle(document.body).backgroundColor;
        if (transparent(c)) c = getComputedStyle(document.documentElement).backgroundColor;
        if (!transparent(c)) document.documentElement.style.setProperty('--hmn-qs-bg', c);
      }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
      else apply();
    })();

    function findSizeBtn(e) {
      if (e.target && e.target.closest) {
        var direct = e.target.closest('.hmn-qs__size');
        if (direct) return direct;
      }
      if (typeof document.elementsFromPoint === 'function') {
        var stack = document.elementsFromPoint(e.clientX, e.clientY);
        for (var i = 0; i < stack.length; i++) {
          if (stack[i].classList && stack[i].classList.contains('hmn-qs__size')) return stack[i];
        }
      }
      return null;
    }

    function addToCart(id) {
      var clean = String(id).replace(/[^0-9]/g, '');
      var $ = window.jQuery;
      if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart &&
          typeof Shopify.theme.jsAjaxCart.addToCart === 'function' && $) {
        var $form = $(
          '<form action="/cart/add" method="post" enctype="multipart/form-data" style="display:none">' +
          '<input type="hidden" name="id" value="' + clean + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          '</form>'
        );
        $('body').append($form);
        Shopify.theme.jsAjaxCart.addToCart($form);
        setTimeout(function () { $form.remove(); }, 2500);
        return;
      }
      // Fallback (Page/Refresh cart types or cart JS unavailable)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(clean), quantity: 1 })
      }).then(function (r) { if (r.ok) window.location.reload(); });
    }

    // Click — capture phase + geometric hit-test so it beats the card's link.
    document.addEventListener('click', function (e) {
      var btn = findSizeBtn(e);
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.classList.contains('hmn-qs__size--soldout') || btn.getAttribute('aria-disabled') === 'true') return;
      var id = btn.dataset.variantId;
      if (!id) return;
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1200);
      addToCart(id);
    }, true);

    // Hover — driven manually (Flex's product link sits above the buttons).
    var hovered = null;
    function clearHover() { if (hovered) { hovered.classList.remove('is-hover'); hovered = null; } }
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!e.target || !e.target.closest || !e.target.closest('.product__grid-item, .product__thumbnail')) {
        clearHover();
        return;
      }
      var found = null;
      var stack = document.elementsFromPoint(e.clientX, e.clientY);
      for (var i = 0; i < stack.length; i++) {
        if (stack[i].classList && stack[i].classList.contains('hmn-qs__size')) { found = stack[i]; break; }
      }
      if (found && (found.classList.contains('hmn-qs__size--soldout') || found.getAttribute('aria-disabled') === 'true')) found = null;
      if (found === hovered) return;
      clearHover();
      if (found) { found.classList.add('is-hover'); hovered = found; }
    });
    document.addEventListener('pointerleave', clearHover, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
